export default __webpack_public_path__ + "static/concept-play-26c449aa9ea3031dd48600bdfaa19d27.jpg";